import { render, staticRenderFns } from "./DataTableContextMenu.vue?vue&type=template&id=11a8a780&scoped=true&"
import script from "./DataTableContextMenu.vue?vue&type=script&lang=js&"
export * from "./DataTableContextMenu.vue?vue&type=script&lang=js&"
import style0 from "./DataTableContextMenu.vue?vue&type=style&index=0&id=11a8a780&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a8a780",
  null
  
)

export default component.exports